import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Select,
  Box,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import api from '../api';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import UpdateResultModal from '../sections/@dashboard/resultDeclare/UpdateResultModal';
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { row_per_page_data } from 'src/utils/commonUtils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'game_name', label: 'User Name', alignRight: false },
  { id: 'bid_point', label: 'Bid Point', alignRight: false },
  { id: 'winning_point', label: 'Winning Point', alignRight: false },
  { id: 'game_name_2', label: 'Game Name', alignRight: false },
  { id: 'open_panna', label: 'Open Panna', alignRight: false },
  { id: 'open_digit', label: 'Open Digit', alignRight: false },
  { id: 'close_panna', label: 'Close Panna', alignRight: false },
  { id: 'close_digit', label: 'Close Digit', alignRight: false },
  { id: 'session', label: 'Session', alignRight: false },
  { id: 'game_type', label: 'Game Type', alignRight: false },
  { id: 'bid_id', label: 'Bid ID', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function WinnersListPage({ falseLoading }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [winnersData, setWinnersData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');

  const [gameId, setGameId] = useState('');
  const [date, setDate] = useState();
  const [masterGameData, setMasterGameData] = useState([]);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = winnersData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const getAllWinners = async () => {
    dispatch(loadingStartAction());
    const response = await api.get('/winners');
    setWinnersData(response.data);
    dispatch(loadingStopAction());
  };

  const deleteWinner = async () => {
    handleCloseMenu();
    dispatch(loadingStartAction());
    await api.delete(`/winners/${selectedGame._id}`);
    getAllWinners();
  };

  const getAllValues = async () => {
    let apiUrl = `/winners/game-and-date`;

    if (date) {
      const isoFormattedDate = date?.toISOString();
      apiUrl = apiUrl + `?date=${isoFormattedDate}`;
    } else if (gameId) {
      apiUrl = apiUrl + `&game_id=${gameId}`;
    }

    dispatch(loadingStartAction());
    const response = await api.get(apiUrl);
    dispatch(loadingStopAction());
    setWinnersData(response.data.results);
  };

  useEffect(() => {
    getAllWinners();
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - winnersData?.length) : 0;

  const filteredFinalData = applySortFilter(winnersData, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Winners
          </Typography>
          <Stack direction="row" alignItems="center">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  label="Select Date"
                  value={date}
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <Box sx={{ minWidth: 200, marginLeft: 1 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Game</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={gameId}
                  label="Select Game"
                  onChange={(e) => setGameId(e.target.value)}
                >
                  {masterGameData?.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item._id}>
                        {item.game_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>

            <Button onClick={getAllValues}>SUBMIT</Button>
          </Stack>
        </Stack>
        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={winnersData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      bid_points,
                      close_digit,
                      win_points,
                      open_digit,
                      open_pana,
                      date,
                      game,
                      user: { name },
                      bid: { session, close_panna },
                    } = row;
                    const selectedUser = selected.indexOf(game?.game_name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, game?.game_name)} /> */}
                        </TableCell>

                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{bid_points}</TableCell>
                        <TableCell align="left">{win_points}</TableCell>
                        <TableCell align="left">{game?.game_name}</TableCell>
                        <TableCell align="left">{open_pana}</TableCell>
                        <TableCell align="left">{open_digit}</TableCell>
                        <TableCell align="left">{close_panna}</TableCell>
                        <TableCell align="left">{close_digit}</TableCell>
                        <TableCell align="left">{session}</TableCell>
                        <TableCell align="left">--</TableCell>
                        <TableCell align="left">{_id?.slice(0, 5)}...</TableCell>

                        <TableCell align="left">{moment(date).format('MMMM Do YYYY')}</TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={(e) => {
                              setSelectedGame(row);
                              handleOpenMenu(e);
                            }}
                          >
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => deleteWinner()} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
